import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import React, { memo } from 'react';
import { LoadingIcon } from '../Icon';
import styles from './index.module.less';
const variantMap = {
    default: styles.variantDefault,
};
const schemeMap = {
    default: styles.schemeDefault,
    primary: styles.schemePrimary,
    light: styles.schemeLight,
    danger: styles.schemeDanger,
    success: styles.schemeSuccess,
};
export const Button = memo(({ className, size, fullWidth, variant, colorScheme, children, leftIcon, rightIcon, circle, round = true, ...rest }) => {
    const variantClass = variantMap[variant ?? 'default'];
    const schemeClass = schemeMap[colorScheme ?? 'default'];
    return (_jsxs("button", { className: classnames(styles.button, className, {
            [styles.fullWidth]: fullWidth,
            [styles.round]: round,
            [styles.circle]: circle,
        }, size ? styles[size] : null, variantClass, schemeClass), ...rest, children: [leftIcon && (_jsx("span", { className: classnames(styles.iconHolder, styles.leftIcon), children: leftIcon })), children, rightIcon && (_jsx("span", { className: classnames(styles.iconHolder, styles.rightIcon), children: rightIcon }))] }));
});
export const LoadingButton = ({ loading, ...props }) => {
    return (_jsx(Button, { leftIcon: loading ? _jsx(LoadingIcon, { size: 18 }) : undefined, disabled: loading, ...props }));
};
